import React from 'react';
import ArticleComment from './ArticleComment';
import { array } from 'prop-types';

const ArticleCommentList = ({ comments = [] }) => {
    return (<div
        className={'article-comments--container'}>
        <h3>Comments ({comments.length})</h3>
        {comments.map((comment) => (
            <ArticleComment
                key={comment.id}
                name={comment.name}
                email={comment.email}
                message={comment.message}
                createdAt={comment.createdAt} />
        ))}
    </div>);
};

ArticleCommentList.propTypes = {
    comments: array,
};

export default ArticleCommentList;